import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Menu } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class MenuModule extends VuexModule {
  @Action
  [Menu.addMenu](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/menu/save", values, {headers: {'Content-Type': 'application/json'}})
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Menu.viewMenu](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/menu/show", values)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Menu.editMenu](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/editqlchucnang", values)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Menu.deleteMenu](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/menu/delete", values)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Menu.findMenuTree]() {
    return new Promise<void>((resolve, reject) => {
      ApiService.get("/menu/findMenuTree")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  @Action
  [Menu.findMenu](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/menu/findMenu",values)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
  
  @Action
  [Menu.findNavTree](values) {
    return new Promise<void>((resolve, reject) => {
      ApiService.post("/menu/findNavTree", values)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

}
